module.exports = __webpack_public_path__ + "img/Button_AutoSpin.6ba9574c.png";